var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#0B4D79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C25.6383 15 22.0898 18.5485 22.0898 22.9102C22.0898 27.2718 25.6383 30.8203 30 30.8203C34.3617 30.8203 37.9102 27.2718 37.9102 22.9102C37.9102 18.5485 34.3617 15 30 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8418 35.988C37.6761 33.7891 34.8052 32.5781 31.7578 32.5781H28.2422C25.1948 32.5781 22.3239 33.7891 20.1582 35.988C18.0032 38.1761 16.8164 41.0644 16.8164 44.1211C16.8164 44.6065 17.2099 45 17.6953 45H42.3047C42.7901 45 43.1836 44.6065 43.1836 44.1211C43.1836 41.0644 41.9968 38.1761 39.8418 35.988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogo);
export default __webpack_public_path__ + "static/media/admin_logo.9970aee2d7dd0195739bb28515cc6e71.svg";
export { ForwardRef as ReactComponent };